function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "#FFF",
  fillRule: "evenodd",
  transform: "translate(.143 .143)"
}, React.createElement("rect", {
  width: 7.714,
  height: 25.714,
  rx: 0.5
}), React.createElement("path", {
  d: "M0.6409713,36 L7.07331441,36 C7.2961941,36 7.37701566,36.0232064 7.45849714,36.0667832 C7.53997862,36.1103599 7.60392577,36.1743071 7.64750254,36.2557886 C7.69107931,36.3372701 7.71428571,36.4180916 7.71428571,36.6409713 L7.71428571,43.0733144 C7.71428571,43.2961941 7.69107931,43.3770157 7.64750254,43.4584971 C7.60392577,43.5399786 7.53997862,43.6039258 7.45849714,43.6475025 C7.37701566,43.6910793 7.2961941,43.7142857 7.07331441,43.7142857 L0.6409713,43.7142857 C0.418091615,43.7142857 0.337270056,43.6910793 0.255788574,43.6475025 C0.174307093,43.6039258 0.110359949,43.5399786 0.0667831759,43.4584971 C0.0232064028,43.3770157 1.55529404e-16,43.2961941 -2.67679338e-16,43.0733144 L1.72640051e-17,36.6409713 C-1.00308841e-17,36.4180916 0.0232064028,36.3372701 0.0667831759,36.2557886 C0.110359949,36.1743071 0.174307093,36.1103599 0.255788574,36.0667832 C0.337270056,36.0232064 0.418091615,36 0.6409713,36 Z"
}));

var SvgWarning = function SvgWarning(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 8,
    height: 44,
    viewBox: "0 0 8 44",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWarning, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/warning.74cc4e37.svg";
export { ForwardRef as ReactComponent };